import { GetterTree, MutationTree, ActionTree } from "vuex";
import { FeedbackApi } from "@/services/api/FeedbackApi";

class State {
  isFeedbackBusy: boolean;
  feedbackItems: unknown [];
  feedbackItem: unknown;
}

// Создаем объект
const feedbackApi = new FeedbackApi();

// Создаем геттеры
const getters = <GetterTree<State, any>>{

  isFeedbackBusy(state): boolean {
    return state.isFeedbackBusy;
  },

  getFeedbackItems(state): unknown[] {
    return state.feedbackItems;
  },

  getFeedbackItem(state): unknown {
    return state.feedbackItem;
  }
};

// Создаем мутации
const mutations = <MutationTree<State>>{

  setIsFeedbackBusy(state, payload: boolean) {
    state.isFeedbackBusy = payload
  },

  setFeedbackItems(state, payload: unknown[]) {
    state.feedbackItems = payload
  },

  setFeedbackItem(state, payload: unknown) {
    state.feedbackItem = payload
  }
};

// Создаем действия
const actions = <ActionTree<State, any>>{

  // Процесс
  setIsFeedbackBusy({ commit }, data) {
    commit('setIsFeedbackBusy', data ? true : false);
  },
  
  // Список элементов
  getFeedbackItems({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsFeedbackBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};
    const sort:any = data !== undefined && data.sort !== undefined ? data.sort : {};
    const pagination:any = data !== undefined && data.pagination !== undefined ? data.pagination : {};

    return new Promise((resolve, reject) => {

      // Получаем список элементов
      feedbackApi.getFeedbackItems(filter, sort, pagination)
        .then(
          (response) => {
            commit('setFeedbackItems', response);
            commit('setIsFeedbackBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsFeedbackBusy', false);
            reject(error);
          }
        );
    });
  },

  // Создать элемент
  createFeedbackItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsFeedbackBusy', true);

    return new Promise((resolve, reject) => {

      // Создаем элемент
      feedbackApi.createFeedbackItem(data)
        .then(
          (response) => {
            commit('setIsFeedbackBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsFeedbackBusy', false);
            reject(error);
          }
        );
    });
  },

  // Обновить элемент
  updateFeedbackItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsFeedbackBusy', true);

    return new Promise((resolve, reject) => {

      // Обновляем элемент
      feedbackApi.updateFeedbackItem(data)
        .then(
          (response) => {
            commit('setIsFeedbackBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsFeedbackBusy', false);
            reject(error);
          }
        );
    });
  },

  // Удалить элемент
  deleteFeedbackItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsFeedbackBusy', true);

    return new Promise((resolve, reject) => {

      // Удаляем элемент
      feedbackApi.deleteFeedbackItem(data)
        .then(
          (response) => {
            commit('setIsFeedbackBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsFeedbackBusy', false);
            reject(error);
          }
        );
    });
  }
};

// Создаем модуль
const FeedbackModule = {
  state: new State(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

export default FeedbackModule;